import { render, staticRenderFns } from "./AS_QrtlyAccountStatement.vue?vue&type=template&id=aa526a4c&scoped=true&"
import script from "./AS_QrtlyAccountStatement.vue?vue&type=script&lang=js&"
export * from "./AS_QrtlyAccountStatement.vue?vue&type=script&lang=js&"
import style0 from "./AS_QrtlyAccountStatement.vue?vue&type=style&index=0&id=aa526a4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa526a4c",
  null
  
)

export default component.exports